var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGapsInWords(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4371_84183)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -290,
    y: 395,
    width: 362,
    height: 145,
    rx: 26,
    fill: "#1DABF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 396,
    width: 606,
    height: 144,
    rx: 26,
    fill: "#1DABF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -38,
    y: 57,
    width: 542,
    height: 145,
    rx: 26,
    fill: "#1DABF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524,
    y: 58,
    width: 113,
    height: 144,
    rx: 26,
    fill: "#1DABF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -228,
    y: 226,
    width: 362,
    height: 145,
    rx: 26,
    fill: "#1DABF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 226,
    width: 379,
    height: 145,
    rx: 26,
    stroke: "#1DABF2",
    strokeWidth: 9,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553,
    y: 226,
    width: 362,
    height: 145,
    rx: 26,
    fill: "#1DABF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.784 281.455V294.097H185.8V281.455H217.784ZM191.994 269.824H209.44V314.387C209.44 315.061 209.556 315.63 209.788 316.094C210.02 316.536 210.378 316.873 210.863 317.105C211.347 317.316 211.969 317.421 212.727 317.421C213.254 317.421 213.865 317.358 214.56 317.232C215.277 317.105 215.804 317 216.141 316.915L218.669 329.178C217.89 329.41 216.773 329.694 215.319 330.032C213.886 330.369 212.18 330.59 210.199 330.695C206.196 330.906 202.835 330.495 200.117 329.463C197.399 328.409 195.355 326.755 193.986 324.501C192.616 322.246 191.952 319.423 191.994 316.031V269.824ZM248.07 244.413V350.859H231.003V244.413H248.07Z",
    fill: "#1DABF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4371_84183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGapsInWords);
export default __webpack_public_path__ + "static/media/gapsInWords.2c1d7788b874894a5f8efbb19e2e7237.svg";
export { ForwardRef as ReactComponent };